import { StoreMappingUpdatePage } from "@/features/store-mapping/pages/StoreMappingUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/store-mapping/$id/update")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <StoreMappingUpdatePage id={id} />;
}

